/* ui/game/configuration/Configuration.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import AIDropdown from "./AIDropdown.svelte";
import PlantConfiguration from "./PlantConfiguration.svelte";
import SlimeConfiguration from "./SlimeConfiguration.svelte";
import RockConfiguration from "./RockConfiguration.svelte";
import FPS from "./FPS.svelte";

function create_fragment(ctx) {
	let div;
	let fps;
	let t0;
	let aidropdown;
	let t1;
	let plantconfiguration;
	let t2;
	let slimeconfiguration;
	let t3;
	let rockconfiguration;
	let current;
	fps = new FPS({});
	aidropdown = new AIDropdown({});
	plantconfiguration = new PlantConfiguration({});
	slimeconfiguration = new SlimeConfiguration({});
	rockconfiguration = new RockConfiguration({});

	return {
		c() {
			div = element("div");
			create_component(fps.$$.fragment);
			t0 = space();
			create_component(aidropdown.$$.fragment);
			t1 = space();
			create_component(plantconfiguration.$$.fragment);
			t2 = space();
			create_component(slimeconfiguration.$$.fragment);
			t3 = space();
			create_component(rockconfiguration.$$.fragment);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(fps, div, null);
			append(div, t0);
			mount_component(aidropdown, div, null);
			append(div, t1);
			mount_component(plantconfiguration, div, null);
			append(div, t2);
			mount_component(slimeconfiguration, div, null);
			append(div, t3);
			mount_component(rockconfiguration, div, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(fps.$$.fragment, local);
			transition_in(aidropdown.$$.fragment, local);
			transition_in(plantconfiguration.$$.fragment, local);
			transition_in(slimeconfiguration.$$.fragment, local);
			transition_in(rockconfiguration.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(fps.$$.fragment, local);
			transition_out(aidropdown.$$.fragment, local);
			transition_out(plantconfiguration.$$.fragment, local);
			transition_out(slimeconfiguration.$$.fragment, local);
			transition_out(rockconfiguration.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(fps);
			destroy_component(aidropdown);
			destroy_component(plantconfiguration);
			destroy_component(slimeconfiguration);
			destroy_component(rockconfiguration);
		}
	};
}

class Configuration extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Configuration;